import { render, staticRenderFns } from "./InfoForManager.vue?vue&type=template&id=c22dc5ec&scoped=true"
import script from "./InfoForManager.vue?vue&type=script&lang=js"
export * from "./InfoForManager.vue?vue&type=script&lang=js"
import style0 from "./InfoForManager.vue?vue&type=style&index=0&id=c22dc5ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22dc5ec",
  null
  
)

export default component.exports